import PromisedResource from './PromisedResource'

export default class AdAccountsResource extends PromisedResource {
  constructor({ remote, marketingPlatform }) {
    super(remote.query(q => q.findRelatedRecords(marketingPlatform, 'adAccounts')))
  }
}
